import { RouteObject } from 'react-router';

import { instagramOAuthMessage } from '~features/integrations/instagram';
import { OAuthCallback } from '~features/integrations/ui';
import { ROUTES } from '~shared/routes';

export const integrationsOAuthRoutes: RouteObject[] = [
  {
    path: ROUTES.integrations.instagramOAuthSuccess,
    element: (
      <OAuthCallback
        status="success"
        message={instagramOAuthMessage('success')}
      />
    ),
  },
  {
    path: ROUTES.integrations.instagramOAuthError,
    element: (
      <OAuthCallback status="error" message={instagramOAuthMessage('error')} />
    ),
  },
];
